import { BffGamesCategory } from '@lucky7ventures/bff-types';

export const PROVIDERS_OPTIONS_THAILAND = [
  'Pragmatic Play',
  'PG Soft',
  'Microgaming',
  'SA Gaming',
  'Asia Gaming',
  'AE Sexy Baccarat',
  'Spade Gaming',
  'CQ9',
  'Jili',
  'KA Gaming',
  'Habanero',
  'WM Casino',
  'Oriental Game',
  'Simple Play',
  'FA Chai',
  'Vivo Gaming',
] as const;

export const GAMES_FEATURES_THAILAND: readonly BffGamesCategory[] = [
  BffGamesCategory.BonusGame,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Multiplier,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.Gamble,
  BffGamesCategory.Respins,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.Avalanche,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.LevelUp,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.WildNudge,
  BffGamesCategory.Megaways,
  BffGamesCategory.LockedReels,
  BffGamesCategory.AdditiveSymbol,
] as const;

export const thailandTopGameProvidersSlugs = [
  'pragmatic-play',
  'pg-soft',
  'microgaming',
  'sa-gaming',
  'asia-gaming',
  'ae-sexy-baccarat',
  'spade-gaming',
  'cq9',
  'jili',
  'ka-gaming',
  'habanero',
  'wm-casino',
  'oriental-game',
  'simple-play',
  'fa-chai',
  'vivo-gaming',
  'yggdrasil',
  'netent',
  'evolution',
  'playn-go',
  'red-tiger',
  'big-time-gaming',
  'blueprint-gaming',
  'betsoft',
  'relax-gaming',
  'push-gaming',
  'quickspin',
  'playson',
  'thunderkick',
  'wazdan',
  'nolimit-city',
  'hacksaw-gaming',
  'high-5-games',
  'reelplay',
  'skywind',
  'spribe',
  'swintt',
  'endorphina',
  'booming-games',
  '3oaks',
  'oryx',
  'gamomat',
  'golden-hero',
  'kalamba-games',
  'reevo',
  '4-the-player',
  'avatar-ux',
  'jelly-entertainment',
  'peter-&-sons',
];
